import L from 'leaflet';
import { MARKER_ICON_URL } from '../../../config/constants';

const iconPerson = new L.Icon({
  iconUrl: MARKER_ICON_URL,
  iconRetinaUrl: MARKER_ICON_URL,
  iconAnchor: undefined,
  popupAnchor: undefined,
  shadowUrl: undefined,
  shadowSize: undefined,
  shadowAnchor: undefined,
  iconSize: new L.Point(39, 60),
});

export default iconPerson;
